import React from 'react';

import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

const CourseDiscussionEmptyData = () => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={260} py={5} px={3}>
      <Stack direction="column" alignItems="center" gap={1}>
        <Box component="img" src="/static/images/course/course-discussion-empty-data.svg" />
        <Stack direction="column" alignItems="center" gap={2}>
          <Stack direction="column" alignItems="center" gap={1}>
            <Typography variant="body2" color={theme.palette.textV2.secondary}>
              {t('course_detail.course_discussion.empty_data.title')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CourseDiscussionEmptyData;
